import React, { useEffect, useState } from 'react';

// Interrupteur mode clair / mode sombre.
// Le thème est posé sur <html data-theme="..."> (dès le chargement par un petit script dans
// public/index.html, pour éviter un flash blanc) et mémorisé dans le navigateur.
const current = () => document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';

export default function ThemeToggle({ className = '' }) {
  const [theme, setTheme] = useState(current);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', theme === 'dark' ? '#17150f' : '#f5f0e8');
  }, [theme]);

  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    try { localStorage.setItem('theme', next); } catch {}
  };

  const dark = theme === 'dark';
  return (
    <button type="button" className={`theme-toggle ${dark ? 'is-dark' : ''} ${className}`} onClick={toggle}
      aria-label={dark ? 'Passer en mode clair' : 'Passer en mode sombre'} title={dark ? 'Mode clair' : 'Mode sombre'}>
      <span className="theme-toggle-knob">
        {dark ? (
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z" fill="currentColor" /></svg>
        ) : (
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="4.5" fill="currentColor" />
            <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8" />
            </g>
          </svg>
        )}
      </span>
    </button>
  );
}
